module.exports = __webpack_public_path__ + "img/news_detail_1_2.49efa1d7.png";